export enum ECurrencies {
  PEN = 'PEN',
  USD = 'USD',
}

export enum ECurrencySymbols {
  PEN = 'S/',
  USD = '$',
}
